import type { ReactNode } from 'react';

type PublicPanelShellProps = {
  children: ReactNode;
  widthClassName?: string;
};

export function PublicPanelShell({ children, widthClassName = 'max-w-sm' }: PublicPanelShellProps) {
  return (
    <div className="min-h-screen bg-ui-bg px-6 py-10">
      <div className={`mx-auto flex min-h-[calc(100vh-5rem)] w-full flex-col items-center justify-center ${widthClassName}`}>
        {children}
      </div>
    </div>
  );
}

type PublicPanelCardProps = {
  children: ReactNode;
  className?: string;
};

export function PublicPanelCard({ children, className = '' }: PublicPanelCardProps) {
  return (
    <div className={`w-full rounded-2xl border border-ui-border bg-ui-surface p-8 shadow-lg shadow-ui-text/[0.04] ${className}`.trim()}>
      {children}
    </div>
  );
}
